<template>
  <div>
    <bankUserDialog
      :newUserDialog="dialog"
      :button="approve"
      :buttonDelete="buttonDelete"
      @setDialog="dialog = $event"
      @onSaved="deleteBank($event)"
    ></bankUserDialog>
    <v-toolbar dense flat>
      <v-layout row>
        <v-flex xs12 sm5>
          <v-text-field
            v-model="search"
            prepend-icon="search"
            label="Search bank name / bank number / name"
            single-line
            hide-details
            style="padding: 0"
          ></v-text-field>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :loading="loadingMessage"
      :items="filterbanklist"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{
            pagination.page * pagination.rowsPerPage -
              (pagination.rowsPerPage - props.index - 1)
          }}
        </td>
        <td class="text-xs-center">
          {{ props.item.bank_manager_bank.bank_name_en }}
        </td>

        <td class="text-xs-center">
          *{{
            props.item.bank_manager_bank_number.substr(
              props.item.bank_manager_bank_number.length - 4
            )
          }}
        </td>
        <td class="text-xs-center">
          {{ props.item.bank_manager_customer_name }}
        </td>
        <td class="text-xs-center">
          <span
            :class="[
              props.item.bank_manager_status == 1
                ? 'badge_status--active'
                : props.item.bank_manager_status == 2
                ? 'badge_status--inactive'
                : props.item.bank_manager_status == 3
                ? 'badge_status--reject'
                : props.item.bank_manager_status == 4
                ? 'badge_status--delete'
                : null,
            ]"
          >
            {{
              props.item.bank_manager_status == 1
                ? "PENDING"
                : props.item.bank_manager_status == 2
                ? "APPROVE"
                : props.item.bank_manager_status == 3
                ? "REJECT"
                : props.item.bank_manager_status == 4
                ? "DELETE"
                : null
            }}
          </span>
        </td>
        <td class="text-xs-center">
          <v-btn icon @click="BankApprove(props.item.bank_manager_id)">
            <img
              src="@/assets/back-office/icons/approve.svg"
              alt=""
              width="12px"
            />
          </v-btn>
        </td>
        <td class="text-xs-center">
          <v-btn icon @click="BankDeatil(props.item.bank_manager_id)">
            <v-icon small>remove_red_eye</v-icon>
          </v-btn>
        </td>
      </template>
      <template slot="no-data">
        <div v-if="loadingMessage == true">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ "Loading data ..." }}
        </div>
        <div v-else>
          No data available
          <br />
          <v-btn @click="getData()">Reset</v-btn>
        </div>
      </template>
    </v-data-table>
    <v-dialog persistent v-model="deleteDialog" max-width="500">
      <v-card style="border-radius: 10px">
        <v-card-title class="px-4"
          ><h2>Are you want to delete this commission area?</h2>
        </v-card-title>
        <v-divider class="mx-4"></v-divider>
        <v-card-actions class="pr-5 py-4">
          <v-spacer></v-spacer>
          <v-btn
            flat
            dark
            color="red"
            style="
              width: 120px;
              border-radius: 7px;
              font-weight: bold;
              font-size: 16px;
            "
            @click="deleteDialog = false"
            :loading="btnLoading"
            >cancel</v-btn
          >
          <v-btn
            flat
            dark
            color="black"
            style="
              width: 120px;
              background-color: #fddf00;
              border-radius: 7px;
              font-weight: bold;
              font-size: 16px;
            "
            @click="deleteItem()"
            :loading="btnLoading"
            >confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="errSnackbar" color="black" :timeout="3000">
      <v-icon color="red">close</v-icon>
      {{ snackBarMsg || "มีบางอย่างผิดพลาด!" }}
      <v-btn dark flat @click="errSnackbar = false"> Close </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import bankUserDialog from "./BankDetailModal.vue";

export default {
  data: () => ({
    approve: false,
    btnLoading: false,
    deleteDialog: false,
    buttonDelete: null,
    search: "",
    loadingMessage: "black",
    pagination: {
      rowsPerPage: 10,
    },
    dialog: false,
    editDialog: false,
    originalUser: null,
    isDeleting: false,
    headers: [
      {
        text: "No.",
        value: "bank_manager_id",
        sortable: false,
        align: "center",
      },
      {
        text: "Bank Name",
        value: "bank_name_en",
        sortable: false,
        align: "center",
      },
      {
        text: "Number",
        sortable: false,
        value: "bank_manager_customer_id_card",
        align: "center",
      },
      {
        text: "Name",
        sortable: false,
        value: "bank_manager_customer_name",
        align: "center",
      },
      {
        text: "Status",
        value: "bank_manager_status",
        sortable: false,
        align: "center",
      },
      {
        text: "Approve",
        value: "",
        sortable: false,
        align: "center",
      },
      {
        text: "Actions",
        value: "",
        align: "center",
        sortable: false,
        align: "center",
      },
    ],
    errSnackbar: false,
    snackBarMsg: null,
  }),
  components: {
    bankUserDialog,
  },
  computed: {
    ...mapState({
      bankListData: (state) => state.banklist.setStatusBankApprove,
    }),
    filterbanklist() {
      return this.bankListData.filter(
        (val) =>
          (
            val.bank_manager_bank.bank_name_th +
            " " +
            val.bank_manager_bank_number
          )
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          (
            val.bank_manager_bank.bank_name_en +
            " " +
            val.bank_manager_bank_number
          )
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          val.bank_manager_customer_name
            .toLowerCase()
            .includes(this.search.toLowerCase())
      );
    },
  },
  methods: {
    ...mapActions({
      getbankDetail: "banklist/fetchBankByid",
    }),

    toDeleteItem(item) {
      this.deleteDialog = true;
      this.selectedItem = JSON.parse(JSON.stringify(item));
    },
    async deleteItem() {
      this.isDeleting = true;
      let result = await this.$store.dispatch(
        "banklist/deleteBankManagerBackoffice",
        this.selectedItem.bank_manager_id
      );
      this.isDeleting = false;
      if (result == false) return;
      let index = this.bankListData.findIndex(
        (val) => val.bank_manager_id == this.selectedItem.bank_manager_id
      );
      this.bankListData.splice(index, 1);
      this.deleteDialog = false;
    },

    async getData() {
      this.loadingMessage = true;
      await this.$store.dispatch("banklist/fetchBanklistApprove");
      await this.$store.dispatch("banklist/GetCountApproveBank");
      this.loadingMessage = false;
    },
    async BankDeatil(item) {
      this.dialog = true;
      this.approve = false;
      this.isLoading = true;
      await this.getbankDetail(item);
      this.isLoading = false;
    },
    async BankApprove(item) {
      this.dialog = true;
      this.approve = true;
      this.isLoading = true;
      await this.getbankDetail(item);
      this.isLoading = false;
    },
    async deleteBank(payload) {
      payload.done();
      this.dialog = false;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style>
.body__district::-webkit-scrollbar {
  display: none;
  max-height: 150px;
  overflow: auto;
}
.badge_status--active {
  @include badge_item;
  border-radius: 10px;
  background: #fbd200 0% 0% no-repeat padding-box;
  padding: 5px;
}
.badge_status--inactive {
  @include badge_item;

  background: #4caf50 0% 0% no-repeat padding-box;
  height: 26px;
  width: 95px;
}
.badge_status--reject {
  @include badge_item;

  background: #fb3200 0% 0% no-repeat padding-box;
  height: 26px;
  width: 95px;
}
.badge_status--delete {
  @include badge_item;

  background: #9b9a99 0% 0% no-repeat padding-box;
  height: 26px;
  width: 95px;
}
</style>
